module.exports = __webpack_public_path__ + "static/media/amsterdam.275f77b8.jpeg";